import { connect } from "react-redux";
import { login } from "../../redux";
import { LoginView } from "./LoginView";

export default connect((state) => state.root, { login })(LoginView);
